import { iconNames } from './iconNameType';
export const allowedSizes = [
    'sm',
    'md',
    'lg',
    'xl',
    'xxl',
    'xxxl',
    'huge',
    'max',
];
export { iconNames };
